import styled from '@emotion/styled'
import { pxToRem } from 'utils/styled'

export const SDialogModal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 3rem 0 1rem;
  & > svg {
    width: 3rem;
    height: 3rem;
  }
  & > *:not(:last-child) {
    margin-bottom: 1.5rem;
  }
  & > button {
    width: min-content;
    min-width: ${pxToRem(170)}rem;
  }
`

export const SForm = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  & > *:not(:last-child) {
    margin-bottom: 1.5rem;
  }
  & > button {
    margin: 0 auto;
  }
`
